var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDefaultAvatarLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.3724 0 0 5.3724 0 12C0 18.6276 5.3724 24 12 24C18.6276 24 24 18.6276 24 12C24 5.3724 18.6276 0 12 0ZM12 3.3C14.154 3.3 15.9 5.046 15.9 7.2C15.9 9.354 14.154 11.1 12 11.1C9.846 11.1 8.1 9.354 8.1 7.2C8.1 5.046 9.846 3.3 12 3.3ZM12 21.6C8.676 21.6 5.748 19.9104 4.0248 17.3436C5.37 15.3876 9.6552 14.4 12 14.4C14.3448 14.4 18.63 15.3876 19.9752 17.3436C18.252 19.9104 15.324 21.6 12 21.6Z",
    fill: "#0D1A16",
    fillOpacity: 0.7
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultAvatarLight);
export default __webpack_public_path__ + "static/media/default_avatar_light.54c0235e154d55f97f46f5f12785fad6.svg";
export { ForwardRef as ReactComponent };